import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import { FilterPipe } from '../../filter.pipe';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { ToggleService } from '../../services/toggle/toggle.service';
import { User } from '../datamodel/user';
interface Invitations {
	type: any;
}
function mapSnapshot(changes: any) {
	return changes.map(a => {
		const data = a.payload.doc.data() as User;
		const id = a.payload.doc.id;
		return { id, ...data };
	});
}
@Component({
	selector: 'app-invitations',
	templateUrl: './invitations.component.html',
	styleUrls: ['./invitations.component.scss'],
	providers: [WindowService]
})
export class InvitationsComponent implements OnInit {
	tab = 1;
	p: number = 1;
	setTab(newTab) {
		this.tab = newTab;
	};
	isSet = function (tabNum) {
		return this.tab === tabNum;
	};

	private userRef: AngularFirestoreCollection<any>;
	obsUser: Observable<any>;

	private invitationsRef: AngularFirestoreCollection<any>;
	obsInvitations: Observable<any>;

	private providerRef: AngularFirestoreCollection<any>;
	obsProvider: Observable<any>;

	public pendingList = [];
	public doctorsList = [];

	constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, public toggle: ToggleService, private router: Router) { 

	}

	getInvitationsList() {
		let objUser = firebase.auth().currentUser;
		let result = [];
		let afs = this.afs;
		let self = this;
		const userRef = this.afs.collection('users').doc(objUser.uid);
		userRef.valueChanges().subscribe(user => {
			//Get user hospital
			const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
				? user['adminFor'][0].id : '';
			
			self.invitationsRef = afs.collection('provider_invitations', ref => ref.where('hospital_id', '==', userHospId));
			self.invitationsRef.snapshotChanges().map(mapSnapshot).subscribe(idocs => {
				console.log(idocs);
				let pimage = "";
				if (idocs.length > 0){
					idocs.forEach(idoc => {
						if (idoc.status === true) {
							const document = this.afs.collection('providers').doc(idoc.provider_id);
							document.valueChanges().subscribe(data => {
								console.log(data);
								if (data['photo'] && typeof data['photo'] !== "undefined" && data['photo'] !== "") {
									pimage = data['photo'];
								} else {
									pimage = "../../assets/img/provider.png";
								}
								
								self.doctorsList.push({
									first_name: data['first_name'],
									last_name: data['last_name'],
									email: idoc.email,
									photo: pimage,
									npi: data['npi'],
									phone: data['phone'],
									invite_code: idoc.invite_code,
									created: data['created_at']
								});
							});
						}else{
							//find out the provider details
							const document = this.afs.collection('providers').doc(idoc.provider_id);
							document.valueChanges().subscribe(data => {
								console.log(data);
								if (data['photo'] && typeof data['photo'] !== "undefined" && data['photo'] !== "") {
									pimage = data['photo'];
								} else {
									pimage = "../../assets/img/provider.png";
								}
								self.pendingList.push({
									first_name: data['first_name'],
									last_name: data['last_name'],
									email: idoc.email,
									photo: pimage,
									npi: data['npi'],
									phone: data['phone'],
									invite_code: idoc.invite_code,
									created: data['created_at']
								});
							});
						}

					});
				}
			});

		});
	}

	ngOnInit() {
		this.getInvitationsList();
	}

}



// WEBPACK FOOTER //
// ./src/app/modules/invitations/invitations.component.ts